/* Lotus Belle custom behavior for Pipeline 8.2. */

(function () {
  'use strict';

  var hubspotPromise;

  function searchPopdownParts() {
    var popdown = document.getElementById('search-popdown');
    if (!popdown) return null;

    var wrapper = popdown.closest('[data-search-popdown-wrap]');
    return {
      popdown: popdown,
      underlay: wrapper && wrapper.querySelector('[data-search-underlay]'),
      input: popdown.querySelector('[data-predictive-search-input]')
    };
  }

  function openSearchPopdown(trigger) {
    var parts = searchPopdownParts();
    if (!parts) return;

    parts.popdown.classList.add('is-visible');
    if (parts.underlay) parts.underlay.classList.add('underlay--visible');
    trigger.setAttribute('aria-expanded', 'true');
    parts.popdown.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));

    window.requestAnimationFrame(function () {
      if (parts.input) parts.input.focus();
    });
  }

  function closeSearchPopdown() {
    var parts = searchPopdownParts();
    if (!parts) return;

    parts.popdown.classList.remove('is-visible');
    if (parts.underlay) parts.underlay.classList.remove('underlay--visible');
    document.querySelectorAll('.lotusbelle-announcement-search').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    });
    parts.popdown.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
  }

  function handleLocaleControl(event) {
    var toggle = event.target.closest('.lotusbelle-header-locale [data-popout-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();

      var list = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!list) return;

      var shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';
      document.querySelectorAll('.lotusbelle-header-locale .popout-list--visible').forEach(function (openList) {
        if (openList === list) return;
        openList.classList.remove('popout-list--visible');
        var openToggle = document.querySelector('[aria-controls="' + openList.id + '"]');
        if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
      });

      toggle.setAttribute('aria-expanded', String(shouldOpen));
      list.classList.toggle('popout-list--visible', shouldOpen);
      if (shouldOpen) {
        list.style.maxWidth = Math.max(0, document.documentElement.clientWidth - list.getBoundingClientRect().left) + 'px';
      }
      return;
    }

    var option = event.target.closest('.lotusbelle-header-locale [data-popout-option]');
    if (!option) return;

    event.preventDefault();
    event.stopPropagation();

    var localeControl = option.closest('[data-current-locale-root]');
    var currentRoot = (localeControl && localeControl.getAttribute('data-current-locale-root')) || '/';
    var targetRoot = option.getAttribute('data-locale-root') || option.getAttribute('href') || '/';
    var currentPath = window.location.pathname || '/';

    currentRoot = currentRoot === '/' ? '/' : currentRoot.replace(/\/$/, '');
    targetRoot = targetRoot === '/' ? '/' : targetRoot.replace(/\/$/, '');

    var relativePath = currentPath;
    if (currentRoot !== '/' && (currentPath === currentRoot || currentPath.indexOf(currentRoot + '/') === 0)) {
      relativePath = currentPath.slice(currentRoot.length) || '/';
    }

    var targetPath = targetRoot === '/'
      ? relativePath
      : targetRoot + (relativePath === '/' ? '' : relativePath);

    window.location.assign(targetPath + window.location.search + window.location.hash);
  }

  function closeLocalePopoutsOnOutsideClick(event) {
    if (event.target.closest('.lotusbelle-header-locale')) return;

    document.querySelectorAll('.lotusbelle-header-locale .popout-list--visible').forEach(function (list) {
      list.classList.remove('popout-list--visible');
      var toggle = document.querySelector('[aria-controls="' + list.id + '"]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', handleLocaleControl, true);

  function loadHubSpot() {
    if (window.hbspt && window.hbspt.forms) {
      return Promise.resolve(window.hbspt);
    }

    if (hubspotPromise) {
      return hubspotPromise;
    }

    hubspotPromise = new Promise(function (resolve, reject) {
      var existing = document.getElementById('hs-forms-loader') || document.querySelector('script[src*="hsforms.net/forms/embed/v2.js"]');

      var checksRemaining = 200;

      function resolveWhenReady() {
        if (window.hbspt && window.hbspt.forms) {
          resolve(window.hbspt);
          return;
        }
        checksRemaining -= 1;
        if (checksRemaining <= 0) {
          reject(new Error('HubSpot forms API did not become ready.'));
          return;
        }
        window.setTimeout(resolveWhenReady, 50);
      }

      if (existing) {
        resolveWhenReady();
        return;
      }

      var script = document.createElement('script');
      script.id = 'hs-forms-loader';
      script.async = true;
      script.defer = true;
      script.src = 'https://js-eu1.hsforms.net/forms/embed/v2.js';
      script.addEventListener('load', resolveWhenReady, { once: true });
      script.addEventListener('error', function () {
        reject(new Error('HubSpot forms script could not be loaded.'));
      }, { once: true });
      document.head.appendChild(script);
    });

    return hubspotPromise;
  }

  function initHubSpotForms(scope) {
    var root = scope || document;
    var forms = root.querySelectorAll('[data-hubspot-form]:not([data-hubspot-initialized])');
    if (!forms.length) return;

    loadHubSpot().then(function (hbspt) {
      forms.forEach(function (container) {
        var portalId = container.dataset.hubspotPortalId;
        var formId = container.dataset.hubspotFormId;
        var region = container.dataset.hubspotRegion || 'eu1';
        var status = container.querySelector('[data-hubspot-status]');

        if (!portalId || !formId) {
          if (status) status.textContent = 'HubSpot form ID is missing.';
          return;
        }

        container.dataset.hubspotInitialized = 'true';
        if (status) status.remove();

        hbspt.forms.create({
          portalId: portalId,
          formId: formId,
          region: region,
          target: '#' + container.id
        });
      });
    }).catch(function () {
      forms.forEach(function (container) {
        var status = container.querySelector('[data-hubspot-status]');
        if (status) status.textContent = 'The form is temporarily unavailable. Please try again later.';
      });
    });
  }

  function syncTermsGroup(group) {
    var checkbox = group.querySelector('[data-cart-terms-checkbox]');
    var form = group.closest('form') || group.parentElement;
    var checkout = form && form.querySelector('.checkout__button');
    if (!checkbox || !checkout) return;

    checkout.disabled = !checkbox.checked;
    checkout.setAttribute('aria-disabled', String(!checkbox.checked));
  }

  function initCartTerms(scope) {
    (scope || document).querySelectorAll('[data-cart-terms]').forEach(syncTermsGroup);
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-cart-terms-checkbox]')) return;
    syncTermsGroup(event.target.closest('[data-cart-terms]'));
  });

  document.addEventListener('click', function (event) {
    var searchTrigger = event.target.closest('.lotusbelle-announcement-search');
    if (searchTrigger) {
      event.preventDefault();
      var parts = searchPopdownParts();
      if (parts && !parts.popdown.classList.contains('is-visible')) {
        openSearchPopdown(searchTrigger);
      }
      return;
    }

    var searchClose = event.target.closest('#search-popdown [data-close-popdown], [data-search-underlay]');
    if (searchClose) {
      closeSearchPopdown();
      return;
    }

    closeLocalePopoutsOnOutsideClick(event);

    var withdrawalLink = event.target.closest('[data-withdrawal-open]');
    if (!withdrawalLink) return;

    if (window.withdrawalModal && typeof window.withdrawalModal.open === 'function') {
      event.preventDefault();
      window.withdrawalModal.open();
    }
  });

  document.addEventListener('theme:cart:change', function () {
    window.requestAnimationFrame(function () {
      initCartTerms(document);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initHubSpotForms(event.target);
    initCartTerms(event.target);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initHubSpotForms(document);
    initCartTerms(document);
  });
})();
